import { Box, Grid } from '@mui/material';
import React from 'react';

import FundSummaryHeader from './components/FundSummaryHeader';
import NomineesAnalytics from './components/NomineesAnalytics';
import NomineesByPeriod from './components/NomineesByPeriod';
import NomineesDetail from './components/NomineesDetail';
import PaymentTrendsOverview from './components/PaymentTrendsOverview';
import { FundSummaryDataProvider } from './context/FundSummaryDataContext';
import { NomineesPeriodProvider } from './context/NomineesPeriodContext';

const FundSummary: React.FC = () => {
  return (
    <Box sx={{ mb: 3 }}>
      <NomineesPeriodProvider>
        <FundSummaryDataProvider>
          <Grid container rowSpacing={2} columnSpacing={1}>
            <Grid item xs={12}>
              <NomineesByPeriod />
            </Grid>
            <Grid item xs={12}>
              <FundSummaryHeader />
            </Grid>
            <Grid item xs={12}>
              <NomineesDetail />
            </Grid>
            <Grid item xs={12}>
              <NomineesAnalytics />
            </Grid>
            <Grid item xs={12}>
              <PaymentTrendsOverview />
            </Grid>
          </Grid>
        </FundSummaryDataProvider>
      </NomineesPeriodProvider>
    </Box>
  );
};

export default FundSummary;
